import { Box } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import CreateCompanyServices from "./CreateCompanyServices";
import CompanyServicesList from "./CompanyServicesList";
import { CompanyServicesModel } from "model/screensModels/CompanyServicesModel";
import { msgTypes } from "constants/msgTypes";
import { CompanyServicesService } from "services/menu/companyServicesService/CompanyServicesService";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import ApiUrl from "services/shared/ApiUrl";
import { DataNotFound } from "screens/sharedScreens/dataNotFound/DataNotFound";

export default function CompanyServices() {
  const [updateValue, setUpdateValue] = React.useState(
    new CompanyServicesModel()
  );
  const [flag, setFlag] = useState(false);
  const [recentCompanyService, setRecentCompanyService] = useState(new CompanyServicesModel());
    const [isEditMode, setIsEditMode] = useState(false);
  

  React.useEffect(()=>{
    loadRecentCompanyService();
  },[])


  //Prepare request body to Company Service
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = 0;
    requestBody.pageSize = 1;
    return requestBody;
  }

  //Get Company Service list
  const loadRecentCompanyService = async () => {
    const requestBody = prepareRequest();
    const res = await CompanyServicesService.getCompanyServicesList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res?.data !== '') {
        setRecentCompanyService(res?.data?.tbody[0]);
      }else{
        setRecentCompanyService(new CompanyServicesModel());
      }
    }
  }

  //to get update record value
  const getUpdateRecordValue = (CompanyServicesModel: CompanyServicesModel) => {
    setIsEditMode(true);

    setUpdateValue(CompanyServicesModel);
  };

  const addService = () => {
    setUpdateValue(new CompanyServicesModel())
    setIsEditMode(false); // Reset edit mode
    setFlag(true);
  }


  const RecentCompanyService = () => {
    return (
      <>
        <h5 className='pb-3 recent-heading'>Recently added Service </h5>
        {recentCompanyService.serviceId!=='' ? (
        <div>
          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Service Name : </h5>
            </div>
            <div className='col-lg-8'>
              {recentCompanyService.serviceName}
            </div>
          </div>
        </div>
      ) :(
          <>
          <DataNotFound message="There is no Service"/>
          </>
         )}
      </>
    )
  }

  return (
    <Box sx={{ width: "100%" }} className="container container-h-full">
      <Box>
  
        
      <div className="content-subheader">
            {!flag ? (
              <h2 className="mr-3 font-weight-bolder">Company Services List</h2>
            ) : (
              <h2 className=" font-weight-bolder mr-3">{isEditMode ? 'Edit Company Services' : 'Add Company Services'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addService}>  Add Company Services</button>}
          </div>
      </Box>

     
        {!flag ? (
          <div className='sub-content-sec recently-blog'>
            <CompanyServicesList
              setFlag={setFlag}
              updateRecord={getUpdateRecordValue} loadRecentCompanyService= {loadRecentCompanyService}
            ></CompanyServicesList>
          </div>
        ) : (
            <div className='row'>
              <div className='col-lg-4 work'>
                <div className='sub-content-sec recently-blog'>
                  <RecentCompanyService />
                </div>
              </div>
              <div className='col-lg-8'>
                <div className='sub-content-sec recently-blog'>
                  <CreateCompanyServices setFlag={setFlag} updateRecord={updateValue} loadRecentCompanyService= {loadRecentCompanyService}></CreateCompanyServices>
                </div>
              </div>
            </div>
        )}
     
    </Box>
  );
}
